import React from "react";
import "./App.css";

import Layout from "./Components/Layout";

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
